import firebaseConfig from './firebaseConfigs/classyvisatour'; export default firebaseConfig;
